'use strict';

const React = require('react');
const Link = require('../elements/SVTLink');
const FooterTeaserList = (props) => {
	const items = props.model.items;
	return (
		<div className="svtse_footer-destination">
			{items.map(function (item, index) {
				return (
					<span key={index} className="svtse_footer-destination__item">
						<Link className="svtse_footer-destination__link" to={item.url}>{item.title}</Link>
					</span>
				);
			})}
		</div>
	);
};

module.exports = FooterTeaserList;



/** WEBPACK FOOTER **
 ** ./app/components/Footer/FooterDestination.js
 **/